import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { displayDemoModeAlert, inDemoMode } from '@app/lib/remote-login';
import { makeNavigationCancellingError } from '@app/lib/utils';

@Injectable()
export class NoDemoModeGuard implements CanActivateChild, CanActivate {
  constructor(private router: Router) {}

  public canActivate(): boolean {
    if (!inDemoMode()) return true;
    displayDemoModeAlert();
    this.router.navigate(['/']);
    return false;
  }

  public canActivateChild(): boolean {
    if (!inDemoMode()) return true;
    throw makeNavigationCancellingError('Restricted in Demo Mode');
  }
}
